import React, { useState } from "react";
import { generalIcons } from "../assets/js/images";
import { setAdditionalClasses } from "../assets/js/utils";

function Accordion({ items = [] }) {
  const [activeItem, setActiveItem] = useState(Array(items.length).fill(false));

  const handleClickAccordion = (indexClicked) => {
    // if (index === activeItem) setActiveItem(null);
    // else setActiveItem(index);
    setActiveItem(
      activeItem.map((act, index) => (index === indexClicked ? !act : act))
    );
  };
  return items.map((item, index) => (
    <div
      className={`collapsible${setAdditionalClasses(
        ["collapsible--expanded"],
        [activeItem[index]]
      )}`}
    >
      <header
        className="collapsible__header general-m"
        onClick={() => handleClickAccordion(index)}
      >
        <h2 className="collapsible__heading">{item.title}</h2>
        <img
          src={activeItem[index] ? generalIcons[1] : generalIcons[0]}
          alt=""
          className="collapsible__icon"
          style={{
            animation: activeItem[index] ? "fade-in-out .6s  backwards" : "",
            // : "fadeInReverse .7s backwards",
          }}
        />
      </header>
      <div className="collapsible__content general-m-just-wide-screen">
        {item.content}
      </div>
    </div>
  ));
}

export default Accordion;
